import { Component, inject, OnInit } from '@angular/core';
import { AlertsServiceSchedularService } from '../alertsServiceSchedular/alertsServiceSchedular.service';
import { SchedulersService } from '../../schedulers/schedulers.service';
import { AlertsSchedularCreateRequestDTO, AlertsSchedularDTO, AlertsSchedularReadAllDTO, AlertsSchedularUpdateRequestDTO } from '../../schedulers/schedulers.interface';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertsServiceVariablesService } from '../variables/alertServiceVariable.service';
import { AlertsServiceVariablesCreateRequestDTO, AlertsServiceVariablesDeleteRequestDTO, AlertsServiceVariablesDTO, AlertsServiceVariablesReadAllByServiceIdRequestDTO, AlertsServiceVariablesUpdateRequestDTO } from '../variables/alertServiceVariable.interface';
import { ActivatedRoute } from '@angular/router';
import { AlertServiceMasterService } from '../services.services';
import { AlertsServiceMasterReadByIdRequestDTO, AlertsServiceMasterUpdateRequestDTO } from '../services.interface';
import { AlertsServiceSchedularCreateRequestDTO, AlertsServiceSchedularReadByIdRequestDTO, AlertsServiceSchedularReadByServiceIdRequestDTO, AlertsServiceSchedularUpdateRequestDTO } from '../alertsServiceSchedular/alertsServiceSchedular.interface';
import { DBConfigDTO, DBConfigReadAllRequestDTO } from '../../dbconfig/dbconfig.interface';
import { DBConfigService } from '../../dbconfig/dbconfig.service';
import { formatDate } from '@angular/common';
import { debounceTime } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { HistoryService } from '../../history/history.service';
import { NotificationMaster_CreateRequestDTO } from '../../history/history.interface';
import { ToastrService } from 'ngx-toastr';
import { ValueListItemDTO } from 'src/app/Common/ValueListService/ValueListItem.interface';

type SectionKey = 'title' | 'serviceDetails' | 'email' | 'scheduler' | 'variables' | 'postService' | 'attachments';

@Component({
  selector: 'app-alerts-service-details',
  templateUrl: './alerts-service-details.component.html',
  styleUrls: ['./alerts-service-details.component.css']
})

export class AlertsServiceDetailsComponent implements OnInit {

  sanitizer = inject(DomSanitizer)
  alertsServiceSchedularService = inject(AlertsServiceSchedularService);

  historyService = inject(HistoryService);
  alertsSchedularService = inject(SchedulersService);
  alertsServiceVariableService = inject(AlertsServiceVariablesService);
  User = inject(UserLoginService).User();
  route = inject(ActivatedRoute);
  alertsServiceMasterService = inject(AlertServiceMasterService);
  schedularDropDownList: AlertsSchedularDTO[] = [];
  serviceVariableList: AlertsServiceVariablesDTO[] = [];
  isAddingNewVariable: boolean = false;  // Flag to control when a new variable is being added
  ServiceId!: number;
  varTypeOptions: string[] = ['INT', 'STRING'];
  dbConnectionList: DBConfigDTO[] = [];
  dbConfigService = inject(DBConfigService);
  isUniversalEditing: boolean = false;
  editingSection: SectionKey | null = null;
  showSchedulerButtons: boolean = false; // Controls button visibility
  canEditScheduler: boolean = false; // Controls whether editable fields are enabled
  private justSavedScheduler: boolean = false;
  activeSection: string = 'overview';

  get channelConfigRequired(): boolean {
    return ['Email', 'WhatsApp', 'SMS'].includes(this.alertServiceForm.get('alertType')?.value || '');
  }

  get channelIcon(): string {
    const map: Record<string, string> = {
      'Email': 'bi bi-envelope-at-fill',
      'WhatsApp': 'bi bi-whatsapp',
      'SMS': 'bi bi-chat-dots-fill',
      'MSTeams': 'bi bi-microsoft-teams',
      'PowerShellScript': 'bi bi-terminal-fill',
      'Others': 'bi bi-three-dots',
    };
    return map[this.alertServiceForm.get('alertType')?.value ?? ''] || 'bi bi-bell';
  }

  get channelColor(): string {
    const map: Record<string, string> = {
      'Email': '#4251c8',
      'WhatsApp': '#25d366',
      'SMS': '#fbbc05',
      'MSTeams': '#6264a7',
      'PowerShellScript': '#23d18b',
      'Others': '#6c757d',
    };
    return map[this.alertServiceForm.get('alertType')?.value ?? ''] || '#6c757d';
  }

  // Loading states for buttons
  isLoadingSchedulerSave: boolean = false;
  isLoadingServiceUpdate: boolean = false;
  isLoadingTestEmail: boolean = false;
  showAlertSchedularForm: boolean = false;
  isLoading: boolean = false;
  isPageLoading: boolean = false;

  toasterService = inject(ToastrService)

  alertsServiceSchedularForm = new FormGroup({
    mappperId: new FormControl(0),
    serviceId: new FormControl(0, (Validators.required)),
    schedularId: new FormControl(0, (Validators.required)),
    lastExecutionTime: new FormControl(''),
    nextExecutionTime: new FormControl(''),
    startsFrom: new FormControl('', [Validators.required]),
    endsOn: new FormControl('', [Validators.required]),
    dailyStartsOn: new FormControl('', [Validators.required]),
    dailyEndsOn: new FormControl('', [Validators.required]),
    isActive: new FormControl(1)
  })

  alertsServiceVariableForm = new FormGroup({
    variableId: new FormControl(0),
    serviceId: new FormControl(0, [Validators.required]),
    varInstance: new FormControl(''),
    varValue: new FormControl(''),
    varType: new FormControl(''),
    isActive: new FormControl(0)
  })

  serviceVariableForm = new FormGroup({
    variableId: new FormControl(0),
    serviceId: new FormControl(0, [Validators.required]),
    varInstance: new FormControl(''),
    varValue: new FormControl(''),
    varType: new FormControl(''),
    isActive: new FormControl(0),
    isEditing: new FormControl(true)
  })

  alertServiceForm = new FormGroup({
    serviceId: new FormControl(0),
    companyId: new FormControl(0),
    branchId: new FormControl(0),
    softwareId: new FormControl(0),
    title: new FormControl(''),
    sDesc: new FormControl(''),
    alertType: new FormControl(''),
    hasAttachment: new FormControl(false),
    attachmentType: new FormControl(''),
    attachmentPath: new FormControl(''),
    attachmentFileType: new FormControl(''),
    outputFileName: new FormControl(''),
    dataSourceType: new FormControl(''),
    dataSourceDef: new FormControl(''),
    postSendDataSourceType: new FormControl(''),
    postSendDataSourceDef: new FormControl(''),
    emailTo: new FormControl(''),
    ccTo: new FormControl(''),
    bccTo: new FormControl(''),
    aSubject: new FormControl(''),
    aBody: new FormControl(''),
    waTemplateName: new FormControl(''),
    waTemplate: new FormControl(''),
    waLanguageCode: new FormControl(''),
    dbConnid: new FormControl(0),
    alertConfigId: new FormControl(0),
    schedularId: new FormControl(0),
    lastExecutedOn: new FormControl(''),
    nextExecutionTime: new FormControl(''),
    isActive: new FormControl(1),
    isDeleted: new FormControl(0),
    createdBy: new FormControl(''),
    createdOn: new FormControl(0),
    modifiedBy: new FormControl(''),
    modifiedOn: new FormControl(0),
    showPostForm: new FormControl(false),
    showAddScheduler: new FormControl(false),
    status: new FormControl(''),
    testEmailReceiver: new FormControl('')
  });

  alertSchedularForm = new FormGroup({
    schedularId: new FormControl(0),
    aName: new FormControl('', [Validators.required]),
    aCode: new FormControl(''),
    aFreq: new FormControl(0, [Validators.required]),
    sType: new FormControl('', [Validators.required]),
    aDesc: new FormControl(''),
    actionUser: new FormControl(''),
    companyId: new FormControl(0),
    branchId: new FormControl(0),
    softwareId: new FormControl(0),
    isActive: new FormControl(1)
  })

  ngOnInit(): void {
    this.route.paramMap.subscribe(paramMap => {
      this.ServiceId = Number(paramMap.get('id'));

      this.getSchedularDropDownList();
      this.getServiceVariableList();
      this.getAlertServiceSchedular();
      this.getDBConnectionList();

      this.loadAlertServiceMaster();
      this.alertServiceForm.disable();
      this.alertServiceForm.controls.testEmailReceiver.enable()
      // this.alertsServiceSchedularForm.disable();

      // Initially disable scheduler form fields
      this.disableSchedulerFields();
    })

    // Debounce schedularId changes to prevent multiple triggers
    this.alertsServiceSchedularForm.get('schedularId')?.valueChanges.pipe(
      debounceTime(100) // Add slight delay to avoid rapid triggers
    ).subscribe(value => {

      if (!this.isUniversalEditing) { // Only update state if not editing
        this.updateSchedulerState();
      }
    });

  }

  // Disable all sections except the specified one
  disableAllSections(exceptSection: SectionKey | null = null) {
    const sections: Record<SectionKey, FormGroup> = {
      title: this.alertServiceForm,
      serviceDetails: this.alertServiceForm,
      email: this.alertServiceForm,
      scheduler: this.alertsServiceSchedularForm,
      variables: this.alertServiceForm,
      postService: this.alertServiceForm,
      attachments: this.alertServiceForm
    };

    Object.keys(sections).forEach((section) => {
      const key = section as SectionKey; // Type assertion
      // The Attachment card lives inside the same Advanced card as Post Service and shares
      // one Edit toggle, so treat 'attachments' as active whenever 'postService' is being edited.
      const isActiveSection = key === exceptSection || (key === 'attachments' && exceptSection === 'postService');
      if (!isActiveSection) {
        if (key === 'title') {
          this.alertServiceForm.get('title')?.disable();
          this.alertServiceForm.get('sDesc')?.disable();
        } else if (key === 'serviceDetails') {
          this.alertServiceForm.get('dbConnid')?.disable();
          this.alertServiceForm.get('dataSourceType')?.disable();
          this.alertServiceForm.get('dataSourceDef')?.disable();
        } else if (key === 'email') {
          this.alertServiceForm.get('emailTo')?.disable();
          this.alertServiceForm.get('ccTo')?.disable();
          this.alertServiceForm.get('bccTo')?.disable();
          this.alertServiceForm.get('aSubject')?.disable();
          this.alertServiceForm.get('aBody')?.disable();
        } else if (key === 'scheduler') {
          this.disableSchedulerFields();
        } else if (key === 'postService') {
          this.alertServiceForm.get('showPostForm')?.disable();
          this.alertServiceForm.get('postSendDataSourceType')?.disable();
          this.alertServiceForm.get('postSendDataSourceDef')?.disable();
        } else if (key === 'attachments') {
          this.alertServiceForm.get('hasAttachment')?.disable();
          this.alertServiceForm.get('attachmentType')?.disable();
          this.alertServiceForm.get('attachmentPath')?.disable();
          this.alertServiceForm.get('attachmentFileType')?.disable();
          this.alertServiceForm.get('outputFileName')?.disable();
        }
      } else {
        if (key === 'title') {
          this.alertServiceForm.get('title')?.enable();
          this.alertServiceForm.get('sDesc')?.enable();
        } else if (key === 'serviceDetails') {
          this.alertServiceForm.get('dbConnid')?.enable();
          this.alertServiceForm.get('dataSourceType')?.enable();
          this.alertServiceForm.get('dataSourceDef')?.enable();
        } else if (key === 'email') {
          this.alertServiceForm.get('emailTo')?.enable();
          this.alertServiceForm.get('ccTo')?.enable();
          this.alertServiceForm.get('bccTo')?.enable();
          this.alertServiceForm.get('aSubject')?.enable();
          this.alertServiceForm.get('aBody')?.enable();
        } else if (key === 'scheduler') {
          // Only enable fields if a valid schedularId exists
          if (this.alertsServiceSchedularForm.get('schedularId')?.value && this.alertsServiceSchedularForm.get('schedularId')?.value !== 0) {
            this.enableSchedulerFields();
          }
        } else if (key === 'postService') {
          this.alertServiceForm.get('showPostForm')?.enable();
          this.alertServiceForm.get('postSendDataSourceType')?.enable();
          this.alertServiceForm.get('postSendDataSourceDef')?.enable();
          // hasAttachment toggle is in the same Advanced card — enable it here too
          this.alertServiceForm.get('hasAttachment')?.enable();
          this.alertServiceForm.get('attachmentType')?.enable();
          this.alertServiceForm.get('attachmentPath')?.enable();
          this.alertServiceForm.get('attachmentFileType')?.enable();
          this.alertServiceForm.get('outputFileName')?.enable();
        } else if (key === 'attachments') {
          this.alertServiceForm.get('hasAttachment')?.enable();
          this.alertServiceForm.get('attachmentType')?.enable();
          this.alertServiceForm.get('attachmentPath')?.enable();
          this.alertServiceForm.get('attachmentFileType')?.enable();
          this.alertServiceForm.get('outputFileName')?.enable();
        }
      }
    });
    // Update scheduler state after disabling/enabling sections
    this.updateSchedulerState();
  }

  // Start editing a section
  startEditing(section: SectionKey) {
    // If already editing another section, stop it first
    if (this.isUniversalEditing && this.editingSection !== section) {
      this.stopEditing();
    }

    this.isUniversalEditing = true;
    this.editingSection = section;
    this.disableAllSections(section);

    // Ensure scheduler fields are enabled if a valid schedularId exists
    if (section === 'scheduler') {
      const schedularId = this.alertsServiceSchedularForm.get('schedularId')?.value;
      if (typeof schedularId === 'number' && schedularId !== 0) {
        this.canEditScheduler = true;
        this.enableSchedulerFields();
      }
    }
  }

  // Stop editing
  stopEditing() {
    this.isUniversalEditing = false;
    this.editingSection = null;
    this.canEditScheduler = false;
    this.disableAllSections();
  }

  enableDisabledFields() {
    // Enable all fields that are disabled and need to be included
    Object.keys(this.alertServiceForm.controls).forEach(control => {
      const formControl = this.alertServiceForm.get(control);
      if (formControl?.disabled) {
        formControl.enable();  // Temporarily enable it to pass the value
      }
    });
  }

  disableFieldsAgain() {
    Object.keys(this.alertServiceForm.controls).forEach(control => {
      if (control !== 'testEmailReceiver') {
        this.alertServiceForm.get(control)?.disable();
      }
    });
  }



  updateAlertsServiceMaster() {
    this.enableDisabledFields();
    if (this.alertServiceForm.valid) {
      this.isLoadingServiceUpdate = true;
      const formData = this.alertServiceForm.value;

      let data: AlertsServiceMasterUpdateRequestDTO = {
        schedularId: formData.schedularId,
        serviceId: this.ServiceId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId,
        softwareId: parseInt(environment.SoftwareId),
        title: formData.title!,
        sDesc: formData.sDesc ?? "",
        alertType: formData.alertType ?? "",
        hasAttachment: formData.hasAttachment ? 1 : 0, // Convert boolean to 1 or 0,
        attachmentType: formData.attachmentType ?? "",
        attachmentPath: formData.attachmentPath ?? "",
        attachmentFileType: formData.attachmentFileType ?? "",
        outputFileName: formData.outputFileName ?? "",
        dataSourceType: formData.dataSourceType ?? "",
        dataSourceDef: formData.dataSourceDef ?? "",
        postSendDataSourceType: formData.postSendDataSourceType ?? "",
        postSendDataSourceDef: formData.postSendDataSourceDef ?? "",
        emailTo: formData.emailTo ?? "",
        ccTo: formData.ccTo ?? "",
        bccTo: formData.bccTo ?? "",
        aSubject: formData.aSubject ?? "",
        aBody: formData.aBody ?? "",
        waTemplateName: formData.waTemplateName ?? "",
        waTemplate: formData.waTemplate ?? "",
        waLanguageCode: formData.waLanguageCode ?? "",
        dbConnid: Number(formData.dbConnid) ?? "",
        alertConfigId: Number(formData.alertConfigId) ?? "",
        lastExecutedOn: formData.lastExecutedOn ? new Date(formData.lastExecutedOn) : null,
        nextExecutionTime: formData.nextExecutionTime ? new Date(formData.nextExecutionTime) : null,
        actionUser: this.User.userId.toString(),
        isActive: 1
      }

      this.alertsServiceMasterService.AlertServiceMaster_update(data).subscribe((res) => {
        this.loadAlertServiceMaster();
        this.disableFieldsAgain();
        this.stopEditing();
        this.toasterService.success('Service updated successfully', 'Success');
        this.isLoadingServiceUpdate = false;
      }, (error) => {
        console.error('Error updating service:', error);
        this.toasterService.error('Failed to update service', 'Error');
        this.isLoadingServiceUpdate = false;
      })

    }
  }



  // Toggle edit for Service Details
  toggleServiceDetailsEdit() {
    if (this.isUniversalEditing && this.editingSection !== 'serviceDetails') return;
    this.startEditing('serviceDetails');
  }

  // Toggle edit for Email
  toggleEmailEdit() {
    if (this.isUniversalEditing && this.editingSection !== 'email') return;
    this.startEditing('email');
  }

  // Toggle edit for Scheduler
  toggleSchedulerEdit() {
    if (this.isUniversalEditing && this.editingSection !== 'scheduler') return;
    if (!this.isUniversalEditing) {
      this.startEditing('scheduler');
    } else {
      this.stopEditing();
    }
  }

  // Toggle edit for Variables
  toggleVariablesEdit() {
    if (this.isUniversalEditing && this.editingSection !== 'variables') return;
    this.startEditing('variables');
  }

  // Toggle edit for Post Service
  togglePostServiceEdit() {
    if (this.isUniversalEditing && this.editingSection !== 'postService') return;
    this.startEditing('postService');
  }

  // Toggle edit for Attachments
  toggleAttachmentsEdit() {
    if (this.isUniversalEditing && this.editingSection !== 'attachments') return;
    this.startEditing('attachments');
  }

  loadAlertServiceMaster() {
    this.isPageLoading = true
    let data: AlertsServiceMasterReadByIdRequestDTO = {
      serviceId: this.ServiceId,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId
    }

    this.alertsServiceMasterService.AlertServiceMaster_readById(data).subscribe((res) => {
      this.alertServiceForm.patchValue({
        serviceId: res.serviceId,
        companyId: res.tenantId!,
        branchId: res.tenantBranchId!,
        softwareId: res.softwareId!,
        title: res.title!,
        sDesc: res.sDesc ?? null,
        alertType: res.alertType ?? null,
        hasAttachment: res.hasAttachment === 1, // Convert 1/0 to true/false
        attachmentType: res.attachmentType ?? null,
        attachmentPath: res.attachmentPath ?? null,
        attachmentFileType: res.attachmentFileType ?? null,
        outputFileName: res.outputFileName ?? null,
        dataSourceType: res.dataSourceType ?? null,
        dataSourceDef: res.dataSourceDef ?? null,
        postSendDataSourceType: res.postSendDataSourceType ?? null,
        postSendDataSourceDef: res.postSendDataSourceDef ?? null,
        emailTo: res.emailTo ?? null,
        ccTo: res.ccTo ?? null,
        bccTo: res.bccTo ?? null,
        aSubject: res.aSubject ?? null,
        aBody: res.aBody ?? null,
        waTemplateName: res.waTemplateName ?? null,
        waTemplate: res.waTemplate ?? null,
        waLanguageCode: res.waLanguageCode ?? null,
        dbConnid: res.dbConnid ?? null,
        alertConfigId: res.alertConfigId ?? null,
        schedularId: res.schedularId ?? null,
        lastExecutedOn: res.lastExecutedOn ? new Date(res.lastExecutedOn).toDateString() : null,
        nextExecutionTime: res.nextExecutionTime ? new Date(res.nextExecutionTime).toDateString() : null,
        status: res.status
      })
    this.isPageLoading = false
    })
  }

  getDBConnectionList() {
    this.isPageLoading = true
    let data: DBConfigReadAllRequestDTO = {
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      softwareId: parseInt(environment.SoftwareId)
    }

    this.dbConfigService.DBConfig_readAll(data).subscribe((res) => {
      this.dbConnectionList = res.items;
    this.isPageLoading = false
    })
  }

  getSchedularDropDownList() {
    this.isPageLoading = true;
    let data: AlertsSchedularReadAllDTO = {
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      softwareId: parseInt(environment.SoftwareId)
    }

    this.alertsSchedularService.AlertsSchedular_readAll(data).subscribe((res) => {
      this.schedularDropDownList = res.items;
      this.isPageLoading = false;
    })
  }

  getServiceVariableList() {
    this.isPageLoading = true;
    let data: AlertsServiceVariablesReadAllByServiceIdRequestDTO = {
      serviceId: this.ServiceId,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId
    }

    this.alertsServiceVariableService.AlertsServiceVariables_ReadAllByServiceId(data).subscribe((res) => {
      this.serviceVariableList
        = res.items;
    this.isPageLoading = false;
    })
  }

  getAlertServiceSchedular() {
    this.isPageLoading = true;
    let data: AlertsServiceSchedularReadByServiceIdRequestDTO = {
      serviceId: this.ServiceId,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId
    }

    this.alertsServiceSchedularService.AlertsServiceSchedular_readByServiceId(data).subscribe((res) => {
      if (res.items && res.items.length > 0) {
        let schedulerData = res.items[0];
        console.log('Loaded scheduler data:', schedulerData);
        this.alertsServiceSchedularForm.patchValue({
          mappperId: schedulerData.mappperId,
          serviceId: schedulerData.serviceId,
          schedularId: schedulerData.schedularId,
          lastExecutionTime: schedulerData.lastExecutionTime?.toString(),
          nextExecutionTime: schedulerData.nextExecutionTime?.toString(),
          startsFrom: formatDate(schedulerData.startsFrom!, 'yyyy-MM-dd', 'en-US'),
          endsOn: formatDate(schedulerData.endsOn!, 'yyyy-MM-dd', 'en-US'),
          dailyStartsOn: schedulerData.dailyStartOn,
          dailyEndsOn: schedulerData.dailyEndsOn,
          isActive: schedulerData.isActive
        })
        this.disableSchedulerFields();
        this.updateSchedulerState();
      } else {
        this.resetSchedulerForm();
        this.updateSchedulerState();
      }
    this.isPageLoading = false
    }, (error) => {
      console.error('Error loading scheduler:', error);
      this.resetSchedulerForm();
      this.updateSchedulerState();
    this.isPageLoading = false
    })
  }

  onAddVariable() {
    this.isAddingNewVariable = true;

    // Add a new variable with an empty form and include isDeleted property
    this.serviceVariableList.push({
      variableId: 0,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      serviceId: this.ServiceId,  // You can adjust this if needed
      varInstance: '',
      varValue: '',
      varType: '',
      isActive: 1,
      isEditing: true,
      isDeleted: 0  // Add this property to match the interface
    });

    let id = `var${this.serviceVariableList.length - 1}`
    setTimeout(() => {
      const element = document.getElementById(id);
      element!.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
    }, 0)
  }

  onDeleteVariable(index: number) {
    let variable = this.serviceVariableList[index];

    if (variable.variableId) {
      let data: AlertsServiceVariablesDeleteRequestDTO = {
        variableId: variable.variableId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId,
        actionUser: this.User.userId.toString()
      }

      this.alertsServiceVariableService.AlertsServiceVariables_delete(data).subscribe((res) => {
  
        this.serviceVariableList.splice(index, 1);
      })
    } else {
      this.serviceVariableList.splice(index, 1);
    }
  }

  // Method to handle editing the variable
  onEditVariable(index: number) {
    const variable = this.serviceVariableList[index];

    if (variable.isEditing) {
      if (variable.variableId) {
        let data: AlertsServiceVariablesUpdateRequestDTO = {
          variableId: variable.variableId,
          tenantId: this.User.companyId,
          tenantBranchId: this.User.loggedInBranchId,
          serviceId: this.ServiceId,
          varInstance: variable.varInstance!,
          varValue: variable.varValue!,
          varType: variable.varType!,
          isActive: variable.isActive,
          actionUser: this.User.userId.toString()
        }

        this.alertsServiceVariableService.AlertsServiceVariables_update(data).subscribe((res) => {
    
          variable.isEditing = false;
          this.serviceVariableList[index] = res

        })
      } else {
        let data: AlertsServiceVariablesCreateRequestDTO = {
          tenantId: this.User.companyId,
          tenantBranchId: this.User.loggedInBranchId,
          serviceId: variable.serviceId!,
          varInstance: variable.varInstance!,
          varValue: variable.varValue!,
          varType: variable.varType!,
          actionUser: this.User.userId.toString()
        }

        this.alertsServiceVariableService.AlertsServiceVariables_create(data).subscribe((res) => {
    
          variable.isEditing = false;
          this.serviceVariableList[index] = res;
        })
      }
    } else {
      variable.isEditing = true;
    }
  }

  // Disable scheduler form fields (except schedularId)
  disableSchedulerFields() {
    this.alertsServiceSchedularForm.get('startsFrom')?.disable();
    this.alertsServiceSchedularForm.get('endsOn')?.disable();
    this.alertsServiceSchedularForm.get('dailyStartsOn')?.disable();
    this.alertsServiceSchedularForm.get('dailyEndsOn')?.disable();
    // Do NOT disable schedularId - allow selection even when no scheduler exists
    // lastExecutionTime and nextExecutionTime are read-only via template   
  }

  // Enable scheduler form fields
  enableSchedulerFields() {
    this.alertsServiceSchedularForm.get('startsFrom')?.enable();
    this.alertsServiceSchedularForm.get('endsOn')?.enable();
    this.alertsServiceSchedularForm.get('dailyStartsOn')?.enable();
    this.alertsServiceSchedularForm.get('dailyEndsOn')?.enable();
  }

  // Reset scheduler form to initial state
  resetSchedulerForm() {
    this.alertsServiceSchedularForm.reset({
      mappperId: 0,
      serviceId: this.ServiceId,
      schedularId: 0,
      lastExecutionTime: '',
      nextExecutionTime: '',
      startsFrom: '',
      endsOn: '',
      dailyStartsOn: '',
      dailyEndsOn: '',
      isActive: 1
    });
    this.disableSchedulerFields();
  }

  // Update scheduler state based on schedularId
  updateSchedulerState() {
    const schedularId = this.alertsServiceSchedularForm.get('schedularId')?.value;
    const mappperId = this.alertsServiceSchedularForm.get('mappperId')?.value;
    const hasValidScheduler = typeof schedularId === 'number' && schedularId !== 0;

    this.showSchedulerButtons = true;
    this.canEditScheduler = hasValidScheduler && this.isUniversalEditing && this.editingSection === 'scheduler';

    // Update field states based on whether we're editing
    if (this.canEditScheduler) {
      this.enableSchedulerFields();
    } else {
      this.disableSchedulerFields();
    }
  }

  // Normalize time format to HH:MM:SS
  normalizeTimeFormat(time: string | null | undefined): string | null {
    if (!time) {
      return null; // Handle empty or null input
    }

    // Regular expressions for time formats
    const fullTimeRegex = /^([0-1][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/; // HH:MM:SS
    const shortTimeRegex = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/; // HH:MM

    if (fullTimeRegex.test(time)) {
      return time; // Already in HH:MM:SS format
    } else if (shortTimeRegex.test(time)) {
      return `${time}:00`; // Append :00 for HH:MM
    }

    // Invalid format, return null or handle as needed
    console.warn(`Invalid time format: ${time}`);
    return null;
  }

  saveSchedular() {

    this.alertsServiceSchedularForm.markAllAsTouched();


    const schedularId = this.alertsServiceSchedularForm.get('schedularId')?.value;
    if (!this.alertsServiceSchedularForm.valid || typeof schedularId !== 'number' || schedularId === 0) {
      return; // Prevent saving if form is invalid or no valid scheduler is selected
    }

    this.isLoadingSchedulerSave = true;
    let formData = this.alertsServiceSchedularForm.getRawValue(); // Use getRawValue to get values from disabled controls

    if (formData.mappperId && formData.mappperId !== 0) {
      // UPDATE EXISTING SCHEDULER
      let data: AlertsServiceSchedularUpdateRequestDTO = {
        mappperId: formData.mappperId,
        serviceId: this.ServiceId,
        schedularId: formData.schedularId!,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId,
        startsFrom: new Date(formData.startsFrom!),
        endsOn: new Date(formData.endsOn!),
        dailyStartOn: this.normalizeTimeFormat(formData.dailyStartsOn)!,
        dailyEndsOn: this.normalizeTimeFormat(formData.dailyEndsOn)!,
        isActive: formData.isActive!,
        actionUser: this.User.userId.toString()
      }


      this.alertsServiceSchedularService.AlertsServiceSchedular_update(data).subscribe((res) => {
  
        this.toasterService.success('Scheduler updated successfully', 'Success');
        this.getAlertServiceSchedular(); // Reload data from server
        this.stopEditing(); // Exit editing mode after saving
        this.updateSchedulerState();
        this.isLoadingSchedulerSave = false;
      }, (error) => {
        console.error('Error updating scheduler:', error);
        this.toasterService.error('Failed to update scheduler', 'Error');
        this.isLoadingSchedulerSave = false;
      })

    } else {
      // CREATE NEW SCHEDULER
      let data: AlertsServiceSchedularCreateRequestDTO = {
        serviceId: this.ServiceId,
        schedularId: formData.schedularId!,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId,
        startsFrom: new Date(formData.startsFrom!),
        endsOn: new Date(formData.endsOn!),
        dailyStartOn: this.normalizeTimeFormat(formData.dailyStartsOn)!,
        dailyEndsOn: this.normalizeTimeFormat(formData.dailyEndsOn)!,
        actionUser: this.User.userId.toString()
      }


      this.alertsServiceSchedularService.AlertsServiceSchedular_create(data).subscribe((res) => {
  
        this.toasterService.success('Scheduler created successfully', 'Success');
        this.getAlertServiceSchedular(); // Reload data to get mappperId
        this.stopEditing(); // Exit editing mode after saving
        this.updateSchedulerState();
        this.isLoadingSchedulerSave = false;
      }, (error) => {
        console.error('Error creating scheduler:', error);
        this.toasterService.error('Failed to create scheduler', 'Error');
        this.isLoadingSchedulerSave = false;
      })
    }
  }

  sendTestEmail() {

    this.alertServiceForm.controls.testEmailReceiver.setValidators([Validators.required, Validators.email]);
    this.alertServiceForm.controls.testEmailReceiver.updateValueAndValidity();
    let formvalues = this.alertServiceForm.getRawValue();

    this.alertServiceForm.markAllAsTouched();

    if (this.alertServiceForm.valid) {
      this.isLoadingTestEmail = true;

      let data: NotificationMaster_CreateRequestDTO = {
        alertConfigId: formvalues.alertConfigId ?? 0,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId,
        softwareId: 1,
        nType: 'Email',
        nSubject: 'Sample Test Bulk Email Template',
        nContent: formvalues.aBody ?? '',
        nTo: formvalues.testEmailReceiver ?? '',
        nCc: '',
        nBcc: '',
        nStatus: 'Pending',
        remarks: '',
        scheduledDate: new Date().toISOString(),
        attachmentPath: '',
        retryCount: 0,
        retryDate: null,
        postSendDataSourceType: '',
        postSendDataSourceDef: '',
        dbConnId: formvalues.dbConnid ?? 0,
        actionUser: this.User.userId.toString(),
      }

      this.historyService.notificationMaster_Create(data).subscribe(res => {
        this.toasterService.success("Test Email Sent Successfully", "Success")
        this.alertServiceForm.controls.testEmailReceiver.setValidators([]);
        this.alertServiceForm.controls.testEmailReceiver.updateValueAndValidity();
        this.alertServiceForm.controls.testEmailReceiver.setValue('');
        this.isLoadingTestEmail = false;
      }, (error) => {
        console.error('Error sending test email:', error);
        this.toasterService.error('Failed to send test email', 'Error');
        this.isLoadingTestEmail = false;
      })

    }
  }

  getSchedularData(id: number | null) {
    if (!id) return null;
    return this.schedularDropDownList.find(x => x.schedularId == id);
  }

  onAddSchedular() {
    this.showAlertSchedularForm = true;
  }

  // onSchedulerTypeChange(event: ValueListItemDTO) {
  //   this.alertSchedularForm.controls.aFreq.patchValue(Number(event.vliDesc ?? '0'));
  // }

  submitAlertSchedularForm() {
    this.alertSchedularForm.markAllAsTouched();
    if (this.alertSchedularForm.valid) {
      const formData = { ...this.alertSchedularForm.value };
      let data = {
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId,
        softwareId: parseInt(environment.SoftwareId),
        schedularId: formData.schedularId as number,
        frequencyInMinutes: formData.aFreq as number,
        iName: formData.aName ?? "",
        iCode: formData.aCode ?? "",
        schedularType: formData.sType ?? "",
        iDesc: formData.aDesc ?? "",
        actionUser: this.User.userId.toString(),
        isActive: 1
      };

        this.createSchedular(data as AlertsSchedularCreateRequestDTO);
    }
  }


  createSchedular(data: AlertsSchedularCreateRequestDTO) {
    this.isLoading = true;
    this.alertsSchedularService.AlertsSchedular_create(data).subscribe({
      next: () => {
        // this.addAlertSchedularModal.close()
        // this.getSchedularsList(this.ReadAllDTO);
        this.isLoading = false;
        this.showAlertSchedularForm = false;
        this.toasterService.success('Schedular created Successfully', 'Success');
        this.getSchedularDropDownList(); // Refresh the dropdown to include the new schedular
      },
      error: (err) => {
        console.log('Error Creating Schedular:', err);
        this.isLoading = false;
      }
    })
  }

  cancelAlertSchedularForm() {
    this.showAlertSchedularForm = false;
  }
}
